import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { SnSearch } from '../../sn-search';
import { Router } from '@angular/router';
import { Connect } from '../../../../../../../classes/connect';

@Component({
    selector: 'app-sn-card-search',
    imports: [
        CommonModule,
        MatTooltipModule,
        TranslateModule,
    ],
    templateUrl: './sn-card-search.component.html',
    styleUrl: './sn-card-search.component.scss'
})
export class SnCardSearchComponent {
  @Input() item!: SnSearch;
  urlMultimedia: string = Connect.urlServerLaraFile;

  constructor(private router: Router) { }

  ngOnInit() {

  }

  goTo(path: string, id: number) {
    this.router.navigate([path, id]);
  }

  downloadRma(src: string, filename: string) {
    if (src) {
      const fullUrl = this.urlMultimedia + src;
      window.open(fullUrl, '_blank');
    }
  }

}
